<template>
  <div class="card" @click="goToForm">
    <div class="card__wrapper">
      <i class="fa fa-plus-circle" />
      <span class="wrapper__text">
        Новое достижение
      </span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToForm() {
      this.$router.push('/achievements/new');
    },
  },
};
</script>

<style scoped>
.card {
  min-height: 250px;
  margin: 10px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.card__wrapper {
  display: inline-flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #fff;
}
.card__wrapper .fa-plus-circle {
  color: rgb(64, 168, 87);
  font-size: 80px;
}
.card__wrapper .wrapper__text {
  font-size: 1.25em;
  text-align: center;
  color: rgb(64, 168, 87);
}
.card:hover,
.card:focus {
  opacity: 0.5;
  cursor: pointer;
  transition: 0.3s;
}
@media (max-width: 419px) {
  .card__wrapper {
    min-height: 280px;
  }
}
</style>



// WEBPACK FOOTER //
// src/user/components/achievements/NewItemCard.vue